import { isEmail, isEmpty } from "validator";

const validateName = (name: string): boolean => {
  return (
    !isEmpty(name) &&
    name.length >= 1 &&
    name.length <= 128 &&
    /^[\p{L}\s'-]+$/u.test(name)
  );
};

const validateEmail = (email: string): boolean => {
  return !isEmpty(email) && isEmail(email);
};

const validateMessage = (message: string): boolean => {
  return !isEmpty(message) && message.length >= 10 && message.length <= 2000;
};

export const useFormValidation = () => {
  const validateField = (name: string, value: string): string | null => {
    switch (name) {
      case "name":
        return validateName(value)
          ? null
          : "Name must be 1-128 characters long and contain only letters, spaces, hyphens, and apostrophes.";
      case "email":
        return validateEmail(value)
          ? null
          : "Please enter a valid email address.";
      case "message":
        return validateMessage(value)
          ? null
          : "Please enter one to two sentences about what you'd like to discuss.";
      default:
        return null;
    }
  };

  return { validateField };
};
